import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {SelectItem} from 'primeng/api';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ConfiguratorDataViewService} from '@tj/tj-dmp-lib-api';

@Component({
    selector: 'dmp-view-for-query',
    templateUrl: './view-for-query.component.html',
    styleUrls: ['./view-for-query.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: ViewForQueryComponent
        }
    ],
    standalone: false
})
export class ViewForQueryComponent implements OnChanges, ControlValueAccessor {
    items: SelectItem[];

    @Input() tenant: string;
    @Input() value: SelectItem;
    @Input() disabled = false;

    @Input() get view(): SelectItem {
        return this.value;
    }

    set view(value: SelectItem) {
        this.value = value;
        this.viewChange.emit(this.value);
    }

    @Output() viewChange = new EventEmitter<SelectItem>();

    touched = false;

    onChange = (value) => { /**/
    };
    onTouched = () => { /**/
    };

    constructor(private configuratorDataViewService: ConfiguratorDataViewService) {
    }

    ngOnChanges(changes: import('@angular/core').SimpleChanges): void {
        this.load();
    }

    private load() {
        if (this.tenant) {
            this.configuratorDataViewService
                .getAllDataViewsUsingGET(this.tenant).subscribe(res => {
                this.items = res.map(r => ({
                    value: r.code,
                    label: r.name
                } as SelectItem));
                if (this.value == null) {
                    this.value = this.items[0];
                } else {
                    this.value = this.items.find(i => i.value === this.value);
                }
            });
        }
    }

    writeValue(code: any): void {
        this.value = code;
        this.updateValue();
    }

    registerOnChange(onChange: any): void {
        this.onChange = onChange;
    }

    registerOnTouched(onTouched: any): void {
        this.onTouched = onTouched;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    markAsTouched() {
        if (!this.touched) {
            this.onTouched();
            this.touched = true;
        }
    }

    dataViewChange(event) {
        this.onChange((this.value as SelectItem).value);
        this.markAsTouched();
        this.viewChange.emit(this.value);
    }

    private updateValue() {
        this.viewChange.emit(this.value);
    }

}
